export default "__VITE_ASSET__CdOPaYO8__"